export class PropertySearchFilter {
  filter: string;
  propertyTypeId: string;

  constructor(filter: string = '', propertyTypeId: string = '') {
    this.filter = filter;
    this.propertyTypeId = propertyTypeId;
  }
}
